import PrivatePolicy from './PrivatePolicy'
import Layout from './Layout'

export { PrivatePolicy, Layout }


// WEBPACK FOOTER //
// ./src/features/ProvatePolicy/components/index.js